/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ResourceReference { 
    value?: string;
    ref?: string;
    display?: string;
    type?: ResourceReference.TypeEnum;
}
export namespace ResourceReference {
    export type TypeEnum = 'direct' | 'indirect' | 'User' | 'Group';
    export const TypeEnum = {
        Direct: 'direct' as TypeEnum,
        Indirect: 'indirect' as TypeEnum,
        User: 'User' as TypeEnum,
        Group: 'Group' as TypeEnum
    };
}


